import React, { useEffect, useState } from "react";
import axios from "axios";
import Papa from "papaparse";
import { Table } from "react-bootstrap";
import "styles/page.css";
import { convertDateFormat } from "utils";

const ForeignExchangeRates = () => {
  const [currencyData, setCurrencyData] = useState({});

  const fetchForexRates = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/foreign-exchange-rates?populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      setCurrencyData(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (_.isEmpty(currencyData)) {
      fetchForexRates();
    }
  }, []);

  return (
    <div className="container page">
      <h1 className="page-title">Exchange Rates</h1>

      <Table
        responsive="xs"
        bordered
        style={{
          color: "#070070",
          border: "none",
        }}
      >
        <thead>
          <tr className="table-title">
            <th colSpan="7">
              As of{" "}
              {!_.isEmpty(currencyData) &&
                convertDateFormat(currencyData?.date)}
            </th>
          </tr>
          <tr className="table-head">
            <th colSpan="2" style={{ textAlign: "start" }}>
              Currency
            </th>
            <th colSpan="1">Selling</th>
            <th colSpan="2">Buying</th>
            <th colSpan="2">Currency Notes</th>
          </tr>
          <tr className="table-subhead">
            <th></th>
            <th></th>
            <th>TT/OD</th>
            <th>TT</th>
            <th>OD</th>
            <th>Selling</th>
            <th>Buying</th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(currencyData) &&
            currencyData?.currencies?.map((currency, index) => {
              const formattedSellingTTOD =
                !isNaN(currency.sellingTTOD) && !isNaN(parseFloat(currency.sellingTTOD))
                  ? parseFloat(currency.sellingTTOD).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5,
                    })
                  : "N/A";
              const formattedBuyingTT =
                !isNaN(currency.buyingTT) && !isNaN(parseFloat(currency.buyingTT))
                  ? parseFloat(currency.buyingTT).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5,
                    })
                  : "N/A";
              const formattedBuyingOD =
                !isNaN(currency.buyingOD) && !isNaN(parseFloat(currency.buyingOD))
                  ? parseFloat(currency.buyingOD).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5,
                    })
                  : "N/A";
              const formattedCurrencyNotesSelling =
                !isNaN(currency.currencyNotesSelling) && !isNaN(parseFloat(currency.currencyNotesSelling))
                  ? parseFloat(currency.currencyNotesSelling).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 5 }
                    )
                  : "N/A";
              const formattedCurrencyNotesBuying =
                !isNaN(currency.currencyNotesBuying) && !isNaN(parseFloat(currency.currencyNotesBuying))
                  ? parseFloat(currency.currencyNotesBuying).toLocaleString(
                      "en-US",
                      { minimumFractionDigits: 2, maximumFractionDigits: 5 }
                    )
                  : "N/A";
              return (
                <tr className="table-data" key={index}>
                  <td>{`${currency.denomination} ${currency.currency}`}</td>{" "}
                  {/* Currency Name */}
                  <td style={{ textAlign: "center" }}>
                    {currency.abbreviation || "N/A"}
                  </td>
                  {/* Currency Code */}
                  <td style={{ textAlign: "center" }}>
                    {formattedSellingTTOD}
                  </td>
                  {/* TT/OD */}
                  <td style={{ textAlign: "center" }}>{formattedBuyingTT}</td>
                  {/* TT */}
                  <td style={{ textAlign: "center" }}>{formattedBuyingOD}</td>
                  {/* OD */}
                  <td style={{ textAlign: "center" }}>
                    {formattedCurrencyNotesSelling}
                  </td>
                  {/* Selling */}
                  <td style={{ textAlign: "center" }}>
                    {formattedCurrencyNotesBuying}
                  </td>
                  {/* Buying */}
                </tr>
              );
            })}
        </tbody>
      </Table>
      <div className="pt-4" style={{ color: "#72788E" }}>
        <p>
          {/* <b> Last updated:</b> 23-Oct-24 at 08:35AM <br /> */}
          <br />
          <b>Note:</b> Exchange rates may change without prior notice. Please
          contact our branches or our 24-Hour Customer Care Consultants for the
          latest rates.
        </p>
      </div>
    </div>
  );
};

export default ForeignExchangeRates;
